// Keeps a muted background video playing on every device: starts it on connect, and if the
// browser blocked autoplay (e.g. iOS Low Power Mode, data saver) retries on the first tap,
// scroll or key press, and whenever the page becomes visible again.
class SAutoplayVideo extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.video.muted = true;
    this.video.defaultMuted = true;
    this.video.playsInline = true;
    this.video.setAttribute('playsinline', '');
    this.video.setAttribute('webkit-playsinline', '');

    const play = () => {
      if (!this.video.paused) return;
      this.video.play().catch(() => {});
    };

    for (const type of ['pointerdown', 'touchstart', 'scroll', 'keydown']) {
      window.addEventListener(type, play, { passive: true, signal });
    }
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') play();
    }, { signal });
    this.video.addEventListener('canplay', play, { signal });

    play();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('s-autoplay-video')) customElements.define('s-autoplay-video', SAutoplayVideo);
